import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const initialState = {
  employees: [],
  branches: [],
  services: [],
  categories: [],
  subCategories: [],
  attributes: [],
  bookings: [],
  notifications: [],
  unread_count: 0,
  loading: false,
  subscriptionData: null,
  mainBranchData: null,
  error: "",
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    setEmployees: (state, action) => {
      state.employees = action.payload;
    },
    addEmployee: (state, action) => {
      state.employees.push(action.payload);
    },
    updateEmployee: (state, action) => {
      const { id, data } = action.payload;
      const index = state.employees.findIndex((emp) => emp.id === id);
      if (index !== -1) {
        state.employees[index] = { ...state.employees[index], ...data };
      }
    },
    deleteEmployees: (state, action) => {
      const ids = action.payload;
      state.employees = state.employees.filter((emp) => !ids.includes(emp.id));
    },
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
    addBranch: (state, action) => {
      state.branches.push(action.payload);
    },
    updateBranch: (state, action) => {
      const { id, data } = action.payload;
      const index = state.branches.findIndex((b) => b.id === id);
      if (index !== -1) {
        state.branches[index] = { ...state.branches[index], ...data };
      }
    },
    deleteBranches: (state, action) => {
      const ids = action.payload;
      state.branches = state.branches.filter((b) => !ids.includes(b.id));
    },
    setServices: (state, action) => {
      state.services = action.payload;
    },
    addService: (state, action) => {
      state.services.unshift(action.payload);
    },
    updateService: (state, action) => {
      const { id, data } = action.payload;
      const index = state.services.findIndex((s) => s.id === id);
      if (index !== -1) {
        state.services[index] = { ...state.services[index], ...data };
      }
    },
    deleteServices: (state, action) => {
      const ids = action.payload;
      state.services = state.services.filter((s) => !ids.includes(s.id));
    },
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    addCategory: (state, action) => {
      state.categories.unshift(action.payload);
    },
    updateCategory: (state, action) => {
      const { id, data } = action.payload;
      const index = state.categories.findIndex((c) => c.id === id);
      if (index !== -1) {
        state.categories[index] = { ...state.categories[index], ...data };
      }
    },
    deleteCategories: (state, action) => {
      state.categories = state.categories.filter(
        (category) => category.id !== action.payload.id
      );
    },
    setSubCategories: (state, action) => {
      state.subCategories = action.payload;
    },
    addSubCategory: (state, action) => {
      state.subCategories.unshift(action.payload);
    },
    updateSubCategory: (state, action) => {
      const { id, data } = action.payload;
      const index = state.subCategories.findIndex((sc) => sc.id === id);
      if (index !== -1) {
        state.subCategories[index] = { ...state.subCategories[index], ...data };
      }
    },
    deleteSubCategories: (state, action) => {
      state.subCategories = state.subCategories.filter(
        (subCategory) => subCategory.id !== action.payload.id
      );
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setBookings: (state, action) => {
      state.bookings = action.payload;
    },
    addBooking: (state, action) => {
      if (!Array.isArray(state.bookings)) {
        state.bookings = [];
      }
      state.bookings.unshift(action.payload);
    },
    updateBooking: (state, action) => {
      const { id, data } = action.payload;
      const index = state.bookings.findIndex((b) => b.id === id);
      if (index !== -1) {
        state.bookings[index] = { ...state.bookings[index], ...data };
      }
    },
    deleteBookings: (state, action) => {
      const ids = action.payload;
      state.bookings = state.bookings.filter((b) => !ids.includes(b.id));
    },
    clearData: () => initialState,
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setSubscription: (state, action) => {
      state.subscriptionData = action.payload;
    },
    setMainBranchData: (state, action) => {
      state.mainBranchData = action.payload;
    },
    setUnreadCount: (state, action) => {
      state.unread_count = action.payload;
    },
  },
});

export const {
  setEmployees,
  addEmployee,
  updateEmployee,
  deleteEmployees,
  setBranches,
  setServices,
  addService,
  updateService,
  deleteServices,
  setCategories,
  addCategory,
  updateCategory,
  deleteCategories,
  setSubCategories,
  addSubCategory,
  updateSubCategory,
  deleteSubCategories,
  setLoading,
  setError,
  addBranch,
  updateBranch,
  deleteBranches,
  setBookings,
  addBooking,
  updateBooking,
  deleteBookings,
  clearData,
  setNotifications,
  setSubscription,
  setUnreadCount,
} = vendorSlice.actions;

export default vendorSlice.reducer;
